import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Button, Form, FormGroup, Label } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { email, length, required } from 'redux-form-validators';
import cx from 'classnames';

// components
import FormField from '../../components/form/field/field';

let ContactAgentForm = (
  {
    className,
    handleSubmit,
    onCancelClick,
    states,
    invalid,
    valid,
    reset,
    error,
    submitSucceeded,
    submitting,
    hideCancel,
    title,
    ...props
  },
  context
) => {
  const BS = context.theme;

  return (
    <Form className={cx(className, BS.alignItemsStart)} onSubmit={handleSubmit}>
      {title && <h5>{title}</h5>}
      {error && <Alert color="danger">{error}</Alert>}
      {submitSucceeded && <Alert color="success">Information sent!</Alert>}
      <FormGroup>
        <Label for="name" className="sr-only">
          Your Name:
        </Label>
        <Field
          name="name"
          type="text"
          placeholder="Your Name"
          component={FormField}
          validate={[required(), length({ max: 255 })]}
        />
      </FormGroup>
      <FormGroup>
        <Label for="email" className="sr-only">
          Email:
        </Label>
        <Field
          name="email"
          type="text"
          placeholder="Email"
          component={FormField}
          validate={[required(), email(), length({ max: 255 })]}
        />
      </FormGroup>
      <FormGroup>
        <Label for="phone" className="sr-only">
          Phone:
        </Label>
        <Field
          name="phone"
          type="text"
          placeholder="Phone"
          component={FormField}
          validate={[length({ max: 255 })]}
        />
      </FormGroup>
      <FormGroup>
        <Label for="comments" className="sr-only">
          Your Message:
        </Label>
        <Field
          name="comments"
          type="textarea"
          placeholder="Your Message"
          component={FormField}
          validate={[required(), length({ max: 10000 })]}
        />
      </FormGroup>
      <div
        className={cx(BS.mb3, {
          [BS.dFlex]: !hideCancel,
          [BS.justifyContentBetween]: !hideCancel
        })}
      >
        {!hideCancel && (
          <Button
            color="warning"
            onClick={e => {
              reset(e);
              if (onCancelClick) {
                onCancelClick(e);
              }
            }}
          >
            Cancel
          </Button>
        )}
        <Button
          type="submit"
          color="dark-blue"
          className={cx({
            [BS.btnBlock]: hideCancel
          })}
          disabled={invalid || submitSucceeded || submitting}
        >
          Contact Agent
        </Button>
      </div>
    </Form>
  );
};

ContactAgentForm.defaultProps = {
  title: 'Contact Agent'
};

ContactAgentForm.contextTypes = {
  theme: PropTypes.object
};

export default reduxForm({
  form: 'contact-agent-form'
})(ContactAgentForm);



// WEBPACK FOOTER //
// ./src/forms/contact-agent-form/contact-agent-form.js